import React from "react";
import UserTypes from "components/auth/user-types";

import DownloadContactsButton from "components/menu/reporting/download-contacts-report";
import DownloadJobsChargeRateButton from "components/menu/reporting/download-jobs-charge-rate-report";
import DownloadMerchandiserPayRateButton from "components/menu/reporting/download-merchandiser-pay-rate";
import ScheduleReportButton from "../menu/reporting/schedule/list";
import PickAndPackReportButton from "../menu/reporting/pick-and-pack/list";
import ChargeApprovalReportButton from "../menu/reporting/charge-approval/list";
import MiscChargeReportButton from "../menu/reporting/misc-charges/list";
import TravelLocationsReportButton from "../menu/reporting/travel-locations/list";
import DailyTravelChargesButton from "../menu/invoicing/dailyTravelCharges/list";

// todo remove dashboard from menu
export default [
    {
        name: "Dashboard",
        url: "/dashboard",
        permission: [],
        menu: [],
        visible: false
    },
    {
        name: "My Schedule",
        url: "/schedules/active",
        permission: [
            // UserTypes.admin,
            // UserTypes.accountManager,
            UserTypes.merchandiser,
            UserTypes.supervisor
        ],
        menu: [],
        params: {
            isPreliminary: false
        }
    },
    {
        name: "Schedule Control",
        url: "",
        permission: [
            UserTypes.admin,
            // UserTypes.accountManager,
            UserTypes.supervisor
        ],
        menu: [
            {
                name: "Draft Schedule",
                url: "/schedule/drafts",
                permission: [
                    UserTypes.admin,
                    UserTypes.accountManager,
                    UserTypes.supervisor
                ],
                menu: []
            },
            {
                name: "Schedule Maintenance",
                url: "/schedules/maintenance",
                permission: [
                    UserTypes.admin,
                    UserTypes.accountManager,
                    UserTypes.supervisor
                ],
                menu: [],
                params: {
                    isPreliminary: true
                }
            },
            {
                name: "Map View",
                url: "/schedules/mapMaintenance",
                permission: [
                    UserTypes.admin,
                    UserTypes.accountManager,
                    UserTypes.supervisor
                ],
                menu: [],
                params: {
                    isPreliminary: true
                }
            }
        ]
    },
    {
        name: "Schedule Maintenance",
        url: "/schedules/maintenance",
        permission: [
            UserTypes.accountManager,
        ],
        menu: []
    },
    {
        name: "Map View",
        url: "/schedules/mapMaintenance",
        permission: [
            UserTypes.accountManager,
        ],
        menu: []
    },
    {
        name: "Summary",
        url: "/summary",
        permission: [
            UserTypes.admin,
            UserTypes.accountManager,
            UserTypes.customer,
            UserTypes.crmUser
        ],
        menu: []
    },
    {
        name: "Orders",
        url: "/order",
        permission: [UserTypes.admin, UserTypes.merchandiser, UserTypes.supervisor,
            UserTypes.accountManager],
        menu: []
    },
    {
        name: "Export",
        url: "",
        permission: [UserTypes.admin, UserTypes.accountManager],
        menu: [
            {
                name: "Orders",
                url: "/orders",
                permission: [UserTypes.admin, UserTypes.accountManager],
                menu: []
            }
        ]
    },
    {
        name: "Master Files",
        url: "",
        permission: [UserTypes.admin, UserTypes.accountManager],
        menu: [
            {
                name: "Company Info",
                url: "/companyInfo",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Location",
                url: "/locations",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Workers",
                url: "/workers",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Jobs",
                url: "/jobMaintenance",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Job Traits",
                url: "/jobTraits",
                permission: [UserTypes.admin, UserTypes.accountManager],
                menu: []
            },
            {
                name: "Products",
                url: "/productMaintenance",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Store Traits",
                url: "/storeTraits",
                permission: [UserTypes.admin, UserTypes.accountManager],
                menu: []
            },
            {
                name: "Service Types",
                url: "/serviceTypes",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Stores",
                url: "/stores",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Retailers",
                url: "/retailers",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Suppliers",
                url: "/suppliers",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "System List",
                url: "/systemList",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Consumer Groups",
                url: "/consumerGroups",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Misc Charges",
                url: "/miscCharges",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Report Builder",
                url: "/reportBuilder",
                permission: [],
                menu: []
            },
            {
                name: "Question Library",
                url: "/questionLibrary",
                permission: [],
                menu: []
            },
            {
                name: "Planogram Maintenance",
                url: "/planogramMaintenance",
                permission: [],
                menu: []
            },
            {
                name: "Order Export Layouts",
                url: "/order-export-layouts",
                permission: [],
                menu: []
            },
            {
                name: "Logs",
                url: "/logs",
                permission: [UserTypes.admin],
                menu: []
            }
        ]
    },
    {
        name: "Reporting",
        url: "",
        permission: [
            UserTypes.admin,
            UserTypes.accountManager,
            UserTypes.supervisor,
            UserTypes.hr
        ],
        menu: [
            {
                name: "Contacts",
                url: "",
                permission: [
                    UserTypes.admin,
                    UserTypes.accountManager,
                    UserTypes.supervisor,
                    UserTypes.hr
                ],
                menu: [],
                component: className => (
                    <DownloadContactsButton title="Contacts" className={className}/>
                )
            },
            {
                name: "JobChargeRate",
                url: "",
                permission: [
                    UserTypes.admin
                ],
                menu: [],
                component: className => (
                    <DownloadJobsChargeRateButton title="Job Charge Rate" className={className}/>
                )
            },
            {
                name: "MerchandiserPayRate",
                url: "",
                permission: [
                    UserTypes.admin
                ],
                menu: [],
                component: className => (
                    <DownloadMerchandiserPayRateButton title="Merchandiser Pay Rate" className={className}/>
                )
            },
            {
                name: "Schedule",
                url: "",
                permission: [
                    UserTypes.admin
                ],
                menu: [],
                component: className => (
                    <ScheduleReportButton title="Schedule" className={className}/>
                )
            },
            {
                name: "PickAndPack",
                url: "",
                permission: [
                    UserTypes.admin
                ],
                menu: [],
                component: className => (
                    <PickAndPackReportButton title="Pick And Pack" className={className}/>
                )
            },
            {
                name: "Charge Approval Report",
                url: "",
                permission: [
                    UserTypes.admin
                ],
                menu: [],
                component: className => (
                    <ChargeApprovalReportButton title="Charge Approval Report" className={className}/>
                )
            },
            {
                name: "Misc Charge Report",
                url: "",
                permission: [
                    UserTypes.admin
                ],
                menu: [],
                component: className => (
                    <MiscChargeReportButton title="Misc Charge Report" className={className}/>
                )
            },
            {
                name: "Travel Locations Report",
                url: "",
                permission: [
                    UserTypes.admin
                ],
                menu: [],
                component: className => (
                    <TravelLocationsReportButton title="Travel Locations Report" className={className}/>
                )
            },
        ]
    },
    {
        name: "Invoicing",
        url: "",
        permission: [
            UserTypes.admin,
            UserTypes.accountManager
        ],
        menu: [
            {
                name: "Merchandiser",
                url: "/invoicing/merchandiser",
                permission: [
                    UserTypes.admin,
                    UserTypes.accountManager
                ],
                menu: []
            },
            {
                name: "Customer",
                url: "/invoicing/customer",
                permission: [
                    UserTypes.admin,
                    UserTypes.accountManager
                ],
                menu: []
            },
            {
                name: "Accounting Export",
                url: "/invoicing/accountingExport",
                permission: [
                    UserTypes.admin
                ],
                menu: []
            },
            {
                name: "Missing Charges",
                url: "/invoicing/missingCharges",
                permission: [
                    UserTypes.admin
                ],
                menu: []
            },
            {
                name: "Daily Travel Charges",
                url: "",
                permission: [
                    UserTypes.admin,
                    UserTypes.accountManager
                ],
                menu: [],
                component: className => (
                    <DailyTravelChargesButton title="Daily Travel Charges" className={className}/>
                )
            },
        ]
    },
    {
        name: "Invoicing",
        url: "/invoicing/merchandiser",
        permission: [
            UserTypes.supervisor,
            UserTypes.merchandiser
        ],
        menu: []
    },
    {
        name: "Email blaster",
        url: "/emailBlaster",
        permission: [
            UserTypes.admin,
            UserTypes.accountManager
        ],
        menu: []
    },
    {
        name: "File Management",
        url: "",
        permission: [UserTypes.admin],
        menu: [
            {
                name: "Internal",
                url: "/fileManager/internal",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "UME",
                url: "/fileManager/ume",
                permission: [UserTypes.admin],
                menu: []
            },
        ]
    },
    {
        name: "File Management",
        url: "/fileManager/internal",
        permission: [UserTypes.merchandiser, UserTypes.supervisor, UserTypes.accountManager],
        menu: []
    },
    // {
    //     name: "File Management",
    //     url: "/fileManager/ume",
    //     permission: [],
    //     menu: []
    // },
    {
        name: "Profile",
        url: "/profile",
        permission: [
            UserTypes.merchandiser
        ],
        menu: [],
    },
    {
        name: "HR",
        url: "",
        permission: [UserTypes.admin, UserTypes.supervisor, UserTypes.hr],
        menu: [
            {
                name: "Job Postings",
                url: "/hr/job-postings",
                permission: [UserTypes.admin, UserTypes.hr],
                menu: []
            },
            {
                name: "Applicants",
                url: "/hr/applicants",
                permission: [UserTypes.admin, UserTypes.hr, UserTypes.supervisor],
                menu: []
            },
            {
                name: "Scoring Criteria",
                url: "/hr/scoring-criteria",
                permission: [UserTypes.admin, UserTypes.hr],
                menu: []
            },
            {
                name: "Interview Categories",
                url: "/hr/interview-categories",
                permission: [UserTypes.admin, UserTypes.hr],
                menu: []
            },
            {
                name: "Interview Questions",
                url: "/hr/interview-questions",
                permission: [UserTypes.admin, UserTypes.hr],
                menu: []
            },
            {
                name: "Prompts",
                url: "/hr/prompts",
                permission: [UserTypes.admin],
                menu: []
            },
            {
                name: "Ingestion Failures",
                url: "/hr/ingestion-failures",
                permission: [UserTypes.admin],
                menu: []
            }
        ]
    }
];
